
export const PROCESSES_COLUMNS = [
    { id: "Type",      label: "Type" },
    { id: "Reference", label: "Reference" },
    { id: "Status",    label: "Status" },
    { id: "Progress",  label: "Progress %" },
    { id: "Total",     label: "Total" },
    { id: "Start",     label: "Start" },
    { id: "End",       label: "End" },
];


export const PROCESSES_ERRORS = {
    FETCH_PROCESS_ERROR: "Error fetching processes:",
};

export const STATUS_COLORS = {
    "Done":        { bg: "#c8e6c9", color: "#1b5e20" },  // light green
    "In Progress": { bg: "#bbdefb", color: "#0d47a1" },  // light blue
    "Pending": { bg: "#eeeeee", color: "#424242" },  // light grey
    "Failed":      { bg: "#ffcdd2", color: "#b71c1c" },  // light red
};